import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import {
  Facebook,
  Instagram,
  Twitter,
  Mail,
  Phone,
  MapPin,
} from "lucide-react";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold bg-gradient-to-r from-amber-400 to-yellow-500 bg-clip-text text-transparent mb-4">
              SunKiss
            </h3>
            <p className="text-gray-300 mb-4 leading-relaxed">{t("aboutUs")}</p>
            <div className="flex space-x-4">
              <a
                target="blank"
                href="https://www.facebook.com/people/SunKiss-Travel-Agency/61583993002825/"
                className="w-10 h-10 rounded-full bg-amber-500/10 flex items-center justify-center hover:bg-amber-500 transition-all duration-300 group"
              >
                <Facebook className="h-5 w-5 text-amber-400 group-hover:text-white transition-colors" />
              </a>
              <a
                target="_blank"
                href="https://www.instagram.com/sunkiss.travel/"
                className="w-10 h-10 rounded-full bg-amber-500/10 flex items-center justify-center hover:bg-amber-500 transition-all duration-300 group"
              >
                <Instagram className="h-5 w-5 text-amber-400 group-hover:text-white transition-colors" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-amber-500/10 flex items-center justify-center hover:bg-amber-500 transition-all duration-300 group"
              >
                <Twitter className="h-5 w-5 text-amber-400 group-hover:text-white transition-colors" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">
              {t("quickLinks")}
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-amber-400 transition-colors"
                >
                  {t("home")}
                </Link>
              </li>
              <li>
                <Link
                  to="/hotels"
                  className="text-gray-300 hover:text-amber-400 transition-colors"
                >
                  {t("hotels")}
                </Link>
              </li>
              <li>
                <Link
                  to="/dubai"
                  className="text-gray-300 hover:text-amber-400 transition-colors"
                >
                  {t("international")}
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-300 hover:text-amber-400 transition-colors"
                >
                  {t("services")}
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-300 hover:text-amber-400 transition-colors"
                >
                  {t("contact")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">
              {t("services")}
            </h4>
            <ul className="space-y-3">
              <li className="text-gray-300">{t("yachtTour")}</li>
              <li className="text-gray-300">{t("cityTour")}</li>
              <li className="text-gray-300">{t("helicopterTour")}</li>
              <li className="text-gray-300">{t("vipTransfer")}</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">
              {t("contact")}
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-amber-400 mt-0.5 flex-shrink-0" />
                <span className="text-gray-300">Antalya, Turkey</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-amber-400 flex-shrink-0" />
                <span className="text-gray-300">+90 242 XXX XX XX</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-amber-400 flex-shrink-0" />
                <span className="text-gray-300">info@sun-kisstravel.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 text-center">
          <p className="text-gray-400">
            © 2025 SunKiss Travel Agency. {t("allRightsReserved")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
